import { AxiosInstance } from 'axios';
import AuthPartner from '@/lib/api/partners/auth';
import Builder from '@/lib/api/dashboard/builder';
import Navigation from '@/lib/api/dashboard/navigation';
import CustomPage from '@/lib/api/dashboard/custom-pages';
import Collections from '@/lib/api/dashboard/collections';
import Products from '@/lib/api/dashboard/products';
import Orders from '@/lib/api/dashboard/orders';
import BlogPosts from '@/lib/api/dashboard/blog-posts';
import Blogs from '@/lib/api/dashboard/blogs';
import FileService from '@/lib/api/dashboard/files-service';
import IntegrationPartner from '@/lib/api/partners/integration';
import Preferences from '@/lib/api/dashboard/preferences';

class Partners {
  public auth: AuthPartner;
  public builder: Builder;
  public collections: Collections;
  public orders: Orders;
  public customPages: CustomPage;
  public products: Products;
  public blogPosts: BlogPosts;
  public blogs: Blogs;
  public navigation: Navigation;
  public preferences: Preferences;
  public fileService: FileService;
  public integration: IntegrationPartner;

  constructor(client: AxiosInstance) {
    this.auth = new AuthPartner(client);
    this.builder = new Builder(client);
    this.collections = new Collections(client);
    this.orders = new Orders(client);
    this.customPages = new CustomPage(client);
    this.products = new Products(client);
    this.blogPosts = new BlogPosts(client);
    this.blogs = new Blogs(client);
    this.navigation = new Navigation(client);
    this.preferences = new Preferences(client);
    this.fileService = new FileService(client);
    this.integration = new IntegrationPartner(client);
  }
}

export default Partners;
